/**
 * useNotificationsFeed — TanStack Query infinite hook pra feed unificado.
 *
 * Spec docs/notificacoes/IMPLEMENTATION_SPEC_V1V2.md §3.2 + §3.3.
 *
 * queryKey: ['notifications-feed', filters-sem-cursor]
 * getNextPageParam: pega next_cursor da response anterior
 */
import { useInfiniteQuery } from '@tanstack/react-query'
import { notificationsFeedApi, type FeedFilters } from '@/api/notifications-feed'

const STALE_TIME_MS = 30_000

export function useNotificationsFeed(filters: FeedFilters) {
  const { cursor: _ignored, ...keyFilters } = filters
  return useInfiniteQuery({
    queryKey: ['notifications-feed', keyFilters],
    queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
      notificationsFeedApi.list({ ...filters, cursor: pageParam }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last) => last.next_cursor ?? undefined,
    staleTime: STALE_TIME_MS,
  })
}
